<div class="container-box p-3">
  <!-- image gallery -->
  <div class="d-flex align-items-center gap-3">
    <h6 class="m-0">
      <span class="text-uppercase" i18n>Rental Gallery</span> -
      <small>{{ rental?.images?.length }}/{{ maxImagesCount }} <ng-container i18n>Images</ng-container></small>
    </h6>
    <div class="flex-fill"></div>
    <button
      class="btn btn-secondary-danger"
      matTooltip="Delete all selected images"
      (click)="deleteSelectedImages()"
      *ngIf="selection?.selected.length"
    >
      <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container> ({{ selection?.selected.length }})
    </button>

    <ul class="internal-module-switcher ml-3">
      <li class="module-item text-lg" [class.active]="viewType == 'list'" i18n-matTooltip matTooltip="List View">
        <a (click)="viewType = 'list'"><i class="cs-icon cs-icon-list-check"></i></a>
      </li>
      <li class="module-item text-lg" [class.active]="viewType == 'grid'" i18n-matTooltip matTooltip="Grid View">
        <a (click)="viewType = 'grid'"><i class="cs-icon cs-icon-grid"></i></a>
      </li>
    </ul>
  </div>

  <div class="mt-3">
    <ng-container *ngIf="viewType === 'grid'">
      <ng-template [ngTemplateOutlet]="cardView"></ng-template>
    </ng-container>
    <ng-container *ngIf="viewType === 'list'">
      <ng-template [ngTemplateOutlet]="listView"></ng-template>
    </ng-container>
  </div>
</div>

<ng-template #cardView>
  <div class="gallery">
    <div ngxDroppable [model]="images" (drop)="onDrop()" class="row">
      <div *ngFor="let image of images; let i = index" class="col-sm-3" ngxDraggable [model]="image">
        <div [ngClass]="{ 'primary-item-container': !!image?.primary }">
          <div
            class="gallery-img gallery-img-container"
            [class.selected]="selection.isSelected(image)"
            [class.highlight]="isHighlighted(image.id)"
            [attr.id]="image.id"
          >
            <a (click)="onOpenImage(i)" class="image-wrapper">
              <img [src]="getImageThumbUrl(image?.secureUrl)" />
            </a>
            <div
              *ngIf="!(1 | isReadonlyRole)"
              class="image-actions-wrapper d-flex justify-content-between align-items-start"
            >
              <div class="left-actions">
                <mat-checkbox
                  class="primary-btn"
                  *ngIf="!image?.primary"
                  (change)="makeImagePrimary(image)"
                  [disableRipple]="true"
                  i18n-matTooltip
                  matTooltip="This image will be shown as a rental image on all views if you mark it as primary."
                >
                  <ng-container i18n>Mark as Primary</ng-container>
                </mat-checkbox>
                <span class="primary-btn" [class.active]="image?.primary" *ngIf="image?.primary">
                  <i class="fal fa-check-square"></i>&nbsp;&nbsp;<ng-container i18n>Primary Image</ng-container>
                </span>
                <span
                  class="remove-image-btn text-danger px-3"
                  (click)="deleteImage(image)"
                  matTooltip="Delete this image"
                  i18n-matTooltip
                  ><i class="cs-icon cs-icon-trash"></i
                ></span>
                <span
                  class="enhance-btn"
                  matTooltip="Enhance this image"
                  i18n-matTooltip
                  (click)="enhanceImage(image)"
                  *ngIf="!image?.metadata?.enhanced"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="#475059">
                    <path
                      d="M13.0907 5.81818L13.9998 3.81818L15.9998 2.90909L13.9998 2L13.0907 0L12.1816 2L10.1816 2.90909L12.1816 3.81818L13.0907 5.81818Z"
                    />
                    <path
                      d="M13.0907 10.1819L12.1816 12.1819L10.1816 13.091L12.1816 14.0001L13.0907 16.0001L13.9998 14.0001L15.9998 13.091L13.9998 12.1819L13.0907 10.1819Z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.81818 2.18188L7.63636 6.18188L11.6364 8.00007L7.63636 9.81825L5.81818 13.8182L4 9.81825L0 8.00007L4 6.18188L5.81818 2.18188ZM5.81818 10.3055L6.53818 8.72007L8.12364 8.00007L6.53818 7.28007L5.81818 5.69461L5.09818 7.28007L3.51273 8.00007L5.09818 8.72007L5.81818 10.3055Z"
                    />
                  </svg>
                  &nbsp;&nbsp;
                  <ng-container i18n>Enhance</ng-container>
                </span>
                <span
                  class="enhance-btn"
                  matTooltip="Revert this image to original"
                  i18n-matTooltip
                  (click)="revertEnhanceImage(image)"
                  *ngIf="!!image?.metadata?.enhanced"
                >
                  <svg width="16" height="7" viewBox="0 0 16 7" fill="#475059">
                    <path
                      d="M8.16667 0.777778C6.10556 0.777778 4.23889 1.54778 2.8 2.8L0 0V7H7L4.18444 4.18444C5.26556 3.28222 6.64222 2.72222 8.16667 2.72222C10.92 2.72222 13.2611 4.51889 14.0778 7L15.9211 6.39333C14.84 3.13444 11.7833 0.777778 8.16667 0.777778Z"
                    />
                  </svg>
                  &nbsp;&nbsp;
                  <ng-container i18n>Revert</ng-container>
                </span>
              </div>
              <div class="right-actions">
                <mat-checkbox
                  class="select-btn"
                  labelPosition="before"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(image) : null"
                  [checked]="selection.isSelected(image)"
                  [disableRipple]="true"
                >
                  {{ selection.isSelected(image) ? 'Selected' : 'Select' }}
                </mat-checkbox>
              </div>
            </div>

            <span
              class="enhance-btn enhanced-badge"
              matTooltip="This image is enhanced"
              i18n-matTooltip
              *ngIf="!!image?.metadata?.enhanced"
            >
              <svg width="16" height="16" viewBox="0 0 16 16">
                <path
                  d="M13.0907 5.81818L13.9998 3.81818L15.9998 2.90909L13.9998 2L13.0907 0L12.1816 2L10.1816 2.90909L12.1816 3.81818L13.0907 5.81818Z"
                />
                <path
                  d="M13.0907 10.1819L12.1816 12.1819L10.1816 13.091L12.1816 14.0001L13.0907 16.0001L13.9998 14.0001L15.9998 13.091L13.9998 12.1819L13.0907 10.1819Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.81818 2.18188L7.63636 6.18188L11.6364 8.00007L7.63636 9.81825L5.81818 13.8182L4 9.81825L0 8.00007L4 6.18188L5.81818 2.18188ZM5.81818 10.3055L6.53818 8.72007L8.12364 8.00007L6.53818 7.28007L5.81818 5.69461L5.09818 7.28007L3.51273 8.00007L5.09818 8.72007L5.81818 10.3055Z"
                />
              </svg>
              &nbsp;&nbsp;
              <ng-container i18n>Enhanced</ng-container>
            </span>
          </div>
          <div class="mt-4">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Category</mat-label>
              <mat-select
                placeholder="Select Category"
                i18n-placeholder
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="image?.metadata.category"
                (selectionChange)="changeCategory(image, $event.value)"
              >
                <mat-option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
          <div class="category-desc">
            <mat-form-field2 class="mat-block">
              <mat-label i18n>Description</mat-label>
              <textarea
                maxlength="280"
                matInput
                [disabled]="1 | isReadonlyRole"
                [(ngModel)]="image?.metadata.description"
                placeholder="Enter a description of this photo"
                i18n-placeholder
                rows="4"
                (change)="changeDescription(image, $event)"
                cdkTextareaAutosize
              ></textarea>
            </mat-form-field2>
          </div>
        </div>
      </div>

      <div class="col-sm-12" *ngIf="rental?.images?.length === 0">
        <p i18n>
          You have not uploaded any image(s) for your rental, please click UPLOAD button to add the image(s) for your
          rental.
        </p>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #listView>
  <tokeet-frontend-image-table
    [images]="images"
    (primary)="makeImagePrimary($event)"
    (delete)="deleteImage($event)"
    (selectChange)="onSelectChange($event)"
  >
    <div class="text-muted m-3" i18n>
      You have not uploaded any image(s) for your rental, please click UPLOAD button to add the image(s) for your
      rental.
    </div>
  </tokeet-frontend-image-table>
</ng-template>
